import React, { useState } from "react";
import styled from "@emotion/styled";
import { Modal, ModalProps } from "../Modal/Modal";
import { Typography } from "../Typography/Typography";
import { Checkbox } from "../Checkbox/Checkbox";
import type { ContactType } from "./types";
import { CONTACT_TYPES_TEXT, TEST_ID_PREFIX } from "./constants";

const WARNING_CONTENT = {
  primary: {
    title: "Updating the Primary Signer will:",
    warnings: [
      "Void any created offers",
      "Require credit or loan approval to be re-submitted for any new contacts",
    ],
  },
  secondary: {
    title: "Updating the Secondary Signer could:",
    warnings: ["Void any created offers", "Void any signed agreements"],
  },

  utility_bill: {
    title: "Updating the Utility Bill Contact could:",
    warnings: ["Void any created offers", "Void any signed agreements"],
  },
};

const UpdateWarningModal = ({
  contactType,
  onConfirm,
  onClose,
  loading,
}: UpdateWarningModalProps) => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <Modal
      type="destructive"
      title={WARNING_CONTENT[contactType].title}
      onClose={onClose}
      primaryButton={{
        text: `Update ${CONTACT_TYPES_TEXT[contactType]}`,
        onClick: onConfirm,
        disabled: loading || !isChecked,
        testId: `${TEST_ID_PREFIX[contactType]}-modal-update`,
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onClose,
        disabled: loading,
        testId: `${TEST_ID_PREFIX[contactType]}-modal-cancel`,
      }}
    >
      {WARNING_CONTENT[contactType].warnings.map((warning, idx) => (
        <TypographyStyled key={`${warning}-${idx}`} role="secondary">
          {warning}
        </TypographyStyled>
      ))}
      <CheckBoxContainer>
        <CheckBoxStyled
          label={`I agree to update the ${CONTACT_TYPES_TEXT[contactType]}`}
          name="update-warning-checkbox"
          data-testid={`${TEST_ID_PREFIX[contactType]}-modal-agree-to-update`}
          onChange={() => setIsChecked(!isChecked)}
          value={String(isChecked)}
        />
      </CheckBoxContainer>
    </Modal>
  );
};

interface UpdateWarningModalProps extends Pick<ModalProps, "onClose"> {
  contactType: ContactType;
  onConfirm: () => void;
  loading?: boolean;
}

const TypographyStyled = styled(Typography)`
  display: list-item;
  margin-left: 1em;
`;

const CheckBoxStyled = styled(Checkbox)`
  span {
    margin-left: 12px;
  }
`;

const CheckBoxContainer = styled.div`
  margin-top: 24px;
`;

export type { UpdateWarningModalProps };

export { UpdateWarningModal };
